module.exports = __webpack_public_path__ + "img/2011-03-28 Rechenzentrum Main Cube EVO Offenbach.eb5bd16e.jpg";